import api from "src/shared/api";
import {
  UsersWithGroupsResponse,
  UsersWithGroupsData,
} from "src/shared/types/dropdowns";

const userDropdownsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserDropdowns: build.query<UsersWithGroupsData, string | void>({
      query: (name) => ({
        url: "/api/dropdowns/users/",
        method: "GET",
        params: name?.trim() ? { name } : undefined,
      }),
      transformResponse: (data: UsersWithGroupsResponse): UsersWithGroupsData =>
        data.data,
    }),
  }),
});

export const { useLazyGetUserDropdownsQuery } = userDropdownsApi;
